import api from "lib/api";

const GET_COMMON_TYPE_LINK = "/v1/dropdown/getCommonTypeByGroupType";
const GET_COMMON_TYPE_COMPANY = "/v1/dropdown/getCommonTypeCompany";

export const getMobileCodes = async (params = {}) => {
  let response = await api.post("/v1/dropdown/getMobileCodes", params);
  let data = response.data;
  data = data.unshift(
    data.splice(
      data.findIndex((item) => item.code === "+66"),
      1
    )[0]
  );
  return response;
};

export const getMstCompanyType = async () => {
  return await api.post(GET_COMMON_TYPE_LINK, {
    groupType: "COMPANY_TYPE",
  });
};

export const getBankOptions = async () => {
  return await api.post(GET_COMMON_TYPE_LINK, {
    groupType: "BANK",
  });
};

export const getCommonTypeByGroupType = async () => {
  return await api.post("/v1/dropdown/getDeductionType", {
    groupType: "DEDUCTION_TYPE",
  });
};

export const getBusinessType = async () => {
  return await api.post(GET_COMMON_TYPE_LINK, {
    groupType: "COMPANY_TYPE",
  });
};
export const getVisaType = async () => {
  return await api.post("/v1/dropdown/getVisaType", {
    groupType: "VISA_TYPE",
  });
};
export const getShiftConditionChangeOptions = async () => {
  return await api.post(GET_COMMON_TYPE_LINK, {
    groupType: "SHIFT_CHANGE",
  });
};

export const getOtReqConditionOptions = async () => {
  return await api.post(GET_COMMON_TYPE_LINK, {
    groupType: "OVERTIME_REQUEST_CONDITION",
  });
};

export const getEmploymentTypeOptions = async (params) => {
  return await api.post("/v1/dropdown/getEmploymentType", params);
};

export const getBreakPeriodTypeOptions = async () => {
  return await api.post(GET_COMMON_TYPE_LINK, {
    groupType: "BREAK_PERIOD_TYPE",
  });
};

export const getProvinceOptions = async () => {
  return await api.post("/v1/dropdown/getProvince");
};

export const getDistrictOptions = async (params = {}) => {
  return await api.post("/v1/dropdown/getDistrict", params);
};

export const getSubDistrictOptions = async (params = {}) => {
  return await api.post("/v1/dropdown/getSubDistrict", params);
};

export const getHolidayTypeOptions = async () => {
  return await api.post(GET_COMMON_TYPE_LINK, {
    groupType: "HOLIDAY_TYPE",
  });
};

export const getDeviceTypeOptions = async () => {
  return await api.post(GET_COMMON_TYPE_LINK, {
    groupType: "DEVICE_TYPE",
  });
};

export const getIncomeDeductionByTypeOptions = async (params = {}) => {
  return await api.post("/v1/dropdown/getIncomeDeductionByType", params);
};

export const getIncomeByCompanyOptions = async (params = {}) => {
  return await api.post("/v1/dropdown/getIncomeByCompany", params);
};
export const getDeductByCompanyOptions = async (params = {}) => {
  return await api.post("/v1/dropdown/getDeductionByCompanyId", params);
};

export const getRoundingTypeOptions = async () => {
  return await api.post(GET_COMMON_TYPE_LINK, {
    groupType: "ROUNDING_TYPE",
  });
};

export const getEmploymentAllOptions = async (params = {}) => {
  return await api.post("/v1/employmentTypeSetup/getEmploymentTypeSetup", {
    ...params,
    actionId: params.actionId,
    companyId: params.companyId,
    employeeId: params.employeeId,
    requestId: params.requestId
  });
};

export const getFrequencyOfPaymentOptions = async () => {
  return await api.post(GET_COMMON_TYPE_LINK, {
    groupType: "FREQUENCY_OF_PAYMENT",
  });
};

export const getTaxCalculationOptions = async () => {
  return await api.post(GET_COMMON_TYPE_LINK, {
    groupType: "TAX_CALCULATION",
  });
};

export const getReasonForSSOOptions = async () => {
  return await api.post("/v1/dropdown/getReasonForSSO");
};

export const getEmployeeTypeOptions = async (params = {}) => {
  return await api.post(GET_COMMON_TYPE_COMPANY, params);
};

export const getEmployeeStatusTypeOptions = async () => {
  return await api.post(GET_COMMON_TYPE_LINK, {
    groupType: "EMPLOYEE_STATUS_TYPE",
  });
};

export const getTitleNameOptions = async () => {
  return await api.post(GET_COMMON_TYPE_LINK, {
    groupType: "TITLE_NAME",
  });
};

export const getTitleNameEnOptions = async () => {
  return await api.post(GET_COMMON_TYPE_LINK, {
    groupType: "TITLE_NAME",
  });
};

export const getWelfareTypeOptions = async () => {
  return await api.post(GET_COMMON_TYPE_LINK, {
    groupType: "WELFARE_TYPE",
  });
};

export const getRoleOptions = async (params = {}) => {
  return await api.post("/v1/rolePermission/getAllRoleForDropdown", params);
};

export const getPeriodTimeUnitOptions = async () => {
  return await api.post(GET_COMMON_TYPE_LINK, {
    groupType: "PERIOD_TIME_UNIT",
  });
};

export const getGenderOptions = async () => {
  return await api.post(GET_COMMON_TYPE_LINK, {
    groupType: "GENDER_OPTION",
  });
};

export const getGender = async () => {
  return await api.post(GET_COMMON_TYPE_LINK, {
    groupType: "GENDER",
  });
};


export const getWelfareLimitOptions = async () => {
  return await api.post(GET_COMMON_TYPE_LINK, {
    groupType: "SET_WELFARE_LIMIT",
  });
};

export const getAttendanceConditionOptions = async () => {
  return await api.post(GET_COMMON_TYPE_LINK, {
    groupType: "ATTENDANCE_CONDITION",
  });
};

export const getCheckInChanelOptions = async () => {
  return await api.post(GET_COMMON_TYPE_LINK, {
    groupType: "CHECKIN_CHANEL",
  });
};

export const getWeekDayWorkingOptions = async () => {
  return await api.post("/v1/dropdown/getWeekDayWorking");
};

export const getWeekWorkingOptions = async () => {
  return await api.post("/v1/dropdown/getWeekWorking");
};

export const getSocialSecurityBranch = async (params = {}) => {
  return await api.post("/v1/dropdown/getBranch", params);
};

export const getsetAcountTypeOption = async (params = {}) => {
  return await api.post("/v1/dropdown/getAccountCategory", params);
};

export const getWelfarePaidOptions = async () => {
  return await api.post(GET_COMMON_TYPE_LINK, {
    groupType: "WELFARE_PAID",
  });
};

export const getTypeOfSlipOptions = async () => {
  return await api.post(GET_COMMON_TYPE_LINK, {
    groupType: "TYPE_OF_SLIP",
  });
};

export const getLeaveGroupOptions = async (params = {}) => {
  return await api.post("/v1/dropdown/getLeaveGroup", params);
};

export const getLeaveRequestConditionOptions = async () => {
  return await api.post(GET_COMMON_TYPE_LINK, {
    groupType: "LEAVE_REQUEST_CONDITION",
  });
};

export const getMonthMstWeekDayWorking = async (params = {}) => {
  return await api.post("/v1/dropdown/getMonthMstWeekDayWorking", params);
};

export const getLeaveCalculationOptions = async () => {
  return await api.post(GET_COMMON_TYPE_LINK, {
    groupType: "LEAVE_CALCULATION",
  });
};

export const getAmountIncomeDeductionOptions = async () => {
  return await api.post(GET_COMMON_TYPE_LINK, {
    groupType: "AMOUNT_INCOME_DEDUCTION",
  });
};

export const getCompanyRegulationOptions = async (params = {}) => {
  return await api.post("/v1/dropdown/getCompanyRegulation", {
    companyId: params.companyId,
  });
};

export const getPenaltiesOptions = async () => {
  return await api.post(GET_COMMON_TYPE_LINK, {
    groupType: "PENALTY",
  });
};

export const getDocumentTypeOptions = async (params = {}) => {
  return await api.post("/v1/dropdown/getDocumentType", params);
};

export const getCountryOptions = async (params = {}) => {
  return await api.post("/v1/dropdown/getAllCountry", params);
};

export const getRaceOptions = async (params = {}) => {
  return await api.post("/v1/dropdown/getNationality", params);
};

export const getNationalityOptions = async (params = {}) => {
  return await api.post("/v1/dropdown/getNationality", params);
};

export const getReligionOptions = async () => {
  return await api.post(GET_COMMON_TYPE_LINK, {
    groupType: "RELIGION",
  });
};

export const getMaritalStatusOptions = async () => {
  return await api.post(GET_COMMON_TYPE_LINK, {
    groupType: "MARITAL_STATUS",
  });
};

export const getMilitaryStatusOptions = async () => {
  return await api.post(GET_COMMON_TYPE_LINK, {
    groupType: "MILITARY_STATUS",
  });
};

export const getBloodGroupOptions = async () => {
  return await api.post(GET_COMMON_TYPE_LINK, {
    groupType: "BLOOD_GROUP",
  });
};

export const getRelationshipOptions = async () => {
  return await api.post(GET_COMMON_TYPE_LINK, {
    groupType: "RELATIONSHIP",
  });
};



export const getEducationDegree = async () => {
  return await api.post(GET_COMMON_TYPE_LINK, {
    groupType: "EDUCATION_DEGREE",
  });
};
export const getInformationTypeOptions = async () => {
  return await api.post(GET_COMMON_TYPE_LINK, {
    groupType: "EDUCATION_DEGREE",
  });
};

export const getMinimumLeaveGroup = async () => {
  return await api.post(GET_COMMON_TYPE_LINK, {
    groupType: "MINIMUM_LEAVE_GROUP",
  });
};

export const getDocumentLimitGroup = async () => {
  return await api.post(GET_COMMON_TYPE_LINK, {
    groupType: "DOCUMENT_LIMIT_GROUP",
  });
};

export const getOccupationOptions = async (params = {}) => {
  return await api.post(GET_COMMON_TYPE_COMPANY, params);
};

export const getLeaveGroupIsLeave = async (params = {}) => {
  return await api.post("/v1/dropdown/getLeaveCategoryGroupIsLeave", params);
};


export const getLeaveGroupIsOffSite = async (params = {}) => {
  return await api.post("/v1/dropdown/getLeaveCategoryGroupIsOffsite", params);
};

export const getSwitchBy = async (params = {}) => {
  return await api.post("/v1/dropdown/getSwitchBy", params);
};

export const getSwitchWith = async (params = {}) => {
  return await api.post("/v1/dropdown/getSwitchWith", params);
};
export const getEmployeSubOrdinates = async (params = {}) => {
  return await api.post("/v1/dropdown/getEmployeSubOrdinates", params);
}

export const getTaxConpany = async (params = {}) => {
  return await api.post("/v1/dropdown/taxCompany", params);
};

export const getCurrency = async (params = {}) => {
  return await api.post("/v1/dropdown/getCurrency", params);
};

export const getMovementGroup = async (params = {}) => {
  return await api.post("/v1/dropdown/getMovementGroup", params);
};

export const getDepartmentOptions = async (params = {}) => {
  return await api.post("/v1/dropdown/getStmDepartment", params);
};

export const getReasonForSeparationOptions = async (params = {}) => {
  return await api.post(GET_COMMON_TYPE_COMPANY, {
    groupType: "REASON_FOR_SEPARATION",
  });
}